// import translations
import de from "@/i18n/locales/de.json";
import en from "@/i18n/locales/en.json";
import { createI18n } from "vue-i18n";

export function getStartingLocale() {
  if (localStorage.getItem("last-locale")) {
    return localStorage.getItem("last-locale");
  }
  return process.env.VUE_APP_I18N_LOCALE || "en";
}

// configure i18n
export const i18n = createI18n({
  legacy: false,
  locale: getStartingLocale(),
  fallbackLocale: "en",
  messages: { de, en },
  globalInjection: true,
});
